import { Text } from 'app/design/primitives/text';
import { View } from 'react-native';
import { HubButton, styles } from '../components';

import type { OfferHubState } from '../hooks';

export function OfferHubLoadingNotice({ t, startList }: Pick<OfferHubState, 't' | 'startList'>) {
  return (
    <View style={styles.notice}>
      <Text accessibilityRole="alert">{t('loadError')}</Text>
      <HubButton
        tone="outline"
        onPress={() => {
          void startList();
        }}
      >
        {t('retryLoading')}
      </HubButton>
    </View>
  );
}
